import { Dispatch, useEffect, useState } from "react";
import { Button, TextField, FormLayout, IconSource, Icon } from "@shopify/polaris";
import { DeleteIcon } from "@shopify/polaris-icons";
import MediaGallery from "../MediaGallery/MediaGallery";
import TextEditor from "../TextEditor/TextEditor";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./ComboProductPage.module.css";
import {
    Action,
    ImageItem,
    StandardConfigInterface,
    BxgyConfigInterface,
    ProductAddonsConfigInterface,
    MixMatchSectionalConfigInterface,
    MixMatchConfigInterface,
} from "../../apps/Bundles/Types";
import { Field } from "@shopify/react-form";

type Props_ComboProductPage = {
    dispatchBundleConfig:
        | Dispatch<Action<StandardConfigInterface>>
        | Dispatch<Action<BxgyConfigInterface>>
        | Dispatch<Action<ProductAddonsConfigInterface>>
        | Dispatch<Action<MixMatchConfigInterface>>
        | Dispatch<Action<MixMatchSectionalConfigInterface>>;
    product_title: any;
    product_description: any;
    images: Field<ImageItem[]>;
    isProductPageVisible: any;
    submit: (event?: React.FormEvent) => Promise<void>;
    double_discount: any;
    collections: any;
    bundle_type?: any;
    products: any;
    default_cta: any;
};

const ComboProductPage = ({
    dispatchBundleConfig,
    product_title,
    product_description,
    images,
    isProductPageVisible,
    submit,
    products,
    default_cta,
}: Props_ComboProductPage) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [showComboFields, setShowComboFields] = useState(isProductPageVisible.value);

    // Update local state when isProductPageVisible changes
    useEffect(() => {
        setShowComboFields(isProductPageVisible.value);
    }, [isProductPageVisible.value]);

    const handleConfirmDelete = () => {
        setModalOpen(false);
        isProductPageVisible.onChange(false);
        dispatchBundleConfig({
            payload: false,
            key: "isProductPageVisible",
        });
        dispatchBundleConfig({
            payload: {
                images: [],
            },
            isComplex: true,
            key: "bundle_as_product",
        });

        dispatchBundleConfig({
            payload: {
                default_cta: true,
            },
            isComplex: true,
            key: "bundles_design",
        });

        default_cta.onChange(true);
        setShowComboFields(false);
        setTimeout(() => {
            isProductPageVisible?.onBlur();
        });
    };
    const handleOpenDeleteModal = () => {
        setModalOpen(true);
    };

    const handleComboProductToggle = () => {
        if (showComboFields) {
            return;
        } else {
            // Reset and enable bundle_as_product fields
            dispatchBundleConfig({
                payload: {
                    images: [],
                },
                isComplex: true,
                key: "bundle_as_product",
            });
            product_description.onChange("");
            product_title.onChange("");
            images.onChange([]);
            dispatchBundleConfig({
                payload: true,
                key: "isProductPageVisible",
            });

            isProductPageVisible.onChange(true);
            dispatchBundleConfig({
                payload: {
                    default_cta: false,
                },
                isComplex: true,
                key: "bundles_design",
            });

            default_cta.onChange(false);
            setShowComboFields(true);
        }
    };

    const handleCancelDelete = () => {
        setModalOpen(false);
    };

    return (
        <>
            <div className={styles.comboProductBanner}>
                <div style={{ flex: 1 }}>
                    <Button onClick={handleComboProductToggle}>
                        {showComboFields ? "Edit product page for this bundle" : "Create product page for this bundle"}
                    </Button>
                </div>
            </div>

            {showComboFields && (
                <FormLayout>
                    <div
                        className={styles.combo_container}
                        style={{
                            position: "relative",
                        }}
                    >
                        <span
                            style={{
                                position: "absolute",
                                right: "5px",
                                top: "4px",
                                cursor: "pointer",
                            }}
                            onClick={() => handleOpenDeleteModal()}
                        >
                            <Icon source={DeleteIcon as IconSource} tone="critical" accessibilityLabel="Delete" />
                        </span>
                        <TextField
                            label="Product Title"
                            autoComplete="off"
                            placeholder="Combo title..."
                            {...product_title}
                            onBlur={product_title?.onBlur}
                            onChange={(val) => {
                                product_title.onChange(val);
                                dispatchBundleConfig({
                                    payload: {
                                        product_title: val,
                                    },
                                    isComplex: true,
                                    key: "bundle_as_product",
                                });
                            }}
                        />

                        <div className={styles.comboDescriptionWrapper}>
                            <label className={styles.comboDescriptionLabel}>Product Description</label>
                            <TextEditor
                                value={product_description?.value}
                                onChange={(val) => {
                                    product_description.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_description: val,
                                        },
                                        isComplex: true,
                                        key: "bundle_as_product",
                                    });
                                }}
                                placeholder="Enter combo description..."
                                className={styles.comboDescriptionEditor}
                            />
                        </div>

                        {/* {bundle_type == "standard" && (
                        <div className={styles.comboTitleWrapper}>
                            <Checkbox
                                label={"Allow Double Discounts"}
                                checked={double_discount?.value}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: {
                                            double_discount: val,
                                        },
                                        isComplex: true,
                                        key: "bundle_as_product",
                                    });
                                    double_discount?.onChange(val);
                                }}
                            />
                        </div>
                    )}
                    <RenderSelectedCollections
                        dispatchBundleConfig={dispatchBundleConfig}
                        submit={submit}
                        collections={collections}
                    /> */}

                        <MediaGallery
                            images={images}
                            products={products}
                            dispatchBundleConfig={dispatchBundleConfig as any}
                            maxFiles={10}
                        />
                    </div>
                </FormLayout>
            )}

            {/* Custom Confirmation Modal */}
            <CustomModal
                open={modalOpen}
                onClose={handleCancelDelete}
                title="Confirm Deletion"
                primaryAction={{
                    content: "Delete",
                    onAction: handleConfirmDelete,
                }}
                secondaryActions={[
                    {
                        content: "Cancel",
                        onAction: handleCancelDelete,
                    },
                ]}
            >
                <p>
                    Are you sure you want to delete the combo product page for this bundle? This action cannot be
                    undone.
                </p>
            </CustomModal>
        </>
    );
};

export default ComboProductPage;
